function Circle({ strokeColor, strokeWidth, strokeDashoffset }) {
  return (
    <div className=" w-full h-full">
      <svg height="100%" width="100%" preserveAspectRatio="xMidYMin">
        <circle
          cx="50%"
          cy="50%"
          r="43%"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={500}
          strokeDashoffset={strokeDashoffset}
        />
      </svg>
    </div>
  );
}

Circle.defaultProps = {
  strokeColor: "#263241",
  strokeWidth: 10,
  strokeDashoffset: 30,
};

export default Circle;
